import { Box, IconButton, InputBase, Paper, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import News from '../../components/tab/tabview/News'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom'
import { IoIosSearch } from "react-icons/io";

export default function NewsComponent() {
  const { darkMode } = useContext(ThemeContext)
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate()


  return (
    <>
    {/* sx={{pb: `116px`,}} */}
      <Box display="flex" flexDirection="column" height="100vh" >
        <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
          <Box display="flex" alignItems="center">
            <IconButton onClick={() => navigate('/quote')}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
            <Typography fontSize={18} fontWeight={600} ml={1}>{t('news')}</Typography>
          </Box>
        </Box>

        <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", px: 2, pt: 1 }}>
          <Paper elevation={0} sx={{ display: "flex", alignItems: "center", gap: 0.8, borderRadius: 2, px: 1.5, py: 0.5, backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
            <IoIosSearch style={{ color: "gray", fontSize: 20, mr: 1 }} />
            <InputBase placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ flex: 1, fontSize: 14, }} />
          </Paper>
        </Box>
        <News searchQuery={searchQuery} />
      </Box>
    </>)
}
